"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheezeWizardsBasicTournament = void 0;
var CheezeWizardsBasicTournamentAbi_json_1 = __importDefault(require("./CheezeWizardsBasicTournamentAbi.json"));
exports.CheezeWizardsBasicTournament = CheezeWizardsBasicTournamentAbi_json_1.default;
